module.exports = __webpack_public_path__ + "static/img/map.c333325.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/work/land-rover/article/map.jpg
// module id = SEzC
// module chunks = 1